import * as React from 'react';

// APP-COMPONENTS
import { freeToSpendTypes, freeToSpendUtils } from 'app-components/flux/free-to-spend';
import { usePreferenceV2 } from 'app-components/flux/preferences-v2';

import Bills from './DialogViews/Bills';
import Income from './DialogViews/Income';
import Intro from './DialogViews/Intro';
import Other from './DialogViews/Other';
import Planned from './DialogViews/Planned';

const { GSFStageEnum } = freeToSpendTypes;

function SpendingPlanFirstUseV2({ initialId, callback }: { initialId?: string; callback?: (catName: string) => void }) {
  const [gettingStartedFlowPhase, _setGettingStartedFlowPhase] = usePreferenceV2(
    'sSPGettingStartedFlowPhase',
    GSFStageEnum.COMPLETE,
  );

  const getCurrentStageView = () => {
    if (!freeToSpendUtils.isStageComplete(gettingStartedFlowPhase, GSFStageEnum.INTRO, false)) {
      return 'INTRO';
    }
    if (!freeToSpendUtils.isStageComplete(gettingStartedFlowPhase, GSFStageEnum.INCOME, false)) {
      return 'INCOME';
    }
    if (!freeToSpendUtils.isStageComplete(gettingStartedFlowPhase, GSFStageEnum.BILLS, false)) {
      return 'BILLS';
    }
    if (!freeToSpendUtils.isStageComplete(gettingStartedFlowPhase, GSFStageEnum.PLANNED, false)) {
      return 'PLANNED';
    }
    return 'OTHER';
  };

  const stage = getCurrentStageView();
  switch (stage) {
    case 'INTRO':
      return <Intro />;
    case 'INCOME':
      return <Income />;
    case 'BILLS':
      return <Bills />;
    case 'PLANNED':
      return <Planned initialId={initialId} callback={callback} />;
    case 'OTHER':
      return <Other />;
    default:
      return <Other />;
  }
}

export default SpendingPlanFirstUseV2;
